import {  FC, Fragment } from 'react'
import {
  StyleGridItems,
  StyleGridItem,
  StyleGridRow,
  StyleGridIconWrapper,
  StyleGridValue,
  StyleGridTitle,
} from './style'
import Row from '@components/row'
import Svg from '@components/svg'
import theme from '@utils/theme'
import { Icons } from '@assets'
import Skeleton from '@components/skeleton'
export interface IStatItemProps {
  title?: string
  value?: string | number
  icon?: keyof typeof Icons
  bg?: keyof typeof theme.colors
}
interface StatGridProps {
  items?: IStatItemProps[]
  loading?: boolean
}
const StatGrid: FC<StatGridProps> = ({
  items,
  loading,
}) => {
  return (
    <StyleGridItems>
      {items?.map((item: IStatItemProps, index: number) => {
        return (
          <Fragment key={index}>
            {!!loading ? (
              <Skeleton radius={8} width={'100%'} height={120} />
            ) : (
              <StyleGridItem>
                <StyleGridRow>
                  <StyleGridRow>
                    <StyleGridIconWrapper bg={item?.bg}>
                      {!!item?.icon && <Svg svg={item?.icon} size={20} />}
                    </StyleGridIconWrapper>
                    <StyleGridValue>{item?.value}</StyleGridValue>
                  </StyleGridRow>
                </StyleGridRow>
                <Row>
                  <StyleGridTitle>{item?.title}</StyleGridTitle>
                </Row>
              </StyleGridItem>
            )}
          </Fragment>
        )
      })}
     
    </StyleGridItems>
  )
}
export default StatGrid